<ng-container *transloco="let t; read: 'cancellationPolicy'">
  <span *ngIf="cancelBeforeDate">
    {{
      t(refundableKey, {
        day: cancelBeforeDate | date: 'longDate',
        time: cancelBeforeDate | date: regionalTimeFormat
      })
    }}
  </span>
</ng-container>
